/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { dateMMMMDDYYYY } from '../../../utils/dateString';

const OrderNumber = ({
    ROSSOrder,
}) => {
   
    const ROSSOrderDateString = dateMMMMDDYYYY(ROSSOrder?.orders?.[0]?.billingProfile?.orderDate);
    const ROSSParentOrderNum = ROSSOrder?.orders?.[0]?.parentOrderNumber;

    return (
        <div className="ross-order-info-wrap">
            <div className="ross-order-info">
                <span className="uppercase gray-color bold">Order #: </span>
                <span className="bold">{ROSSOrder.orderID}</span>
            </div>
            <div className="ross-order-info">
                <span className="uppercase gray-color bold">Order Date: </span>
                <span className="bold">{ROSSOrderDateString}</span>
            </div>
            {ROSSParentOrderNum && (
                <div>
                    <span className="uppercase gray-color bold">Replacement for:</span>
                    <span className="bold">{` ${ROSSParentOrderNum}`}</span>
                </div>
            )}
        </div>
    )
};

OrderNumber.defaultProps = {
    ROSSOrder: {},
};

OrderNumber.propTypes = {
    ROSSOrder: PropTypes.object,
};

export default OrderNumber;
